import { useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onCreateAnAccountClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="login-div">
      <div className="frame-div85">
        <div className="logo1-div7" onClick={onLogo1ContainerClick}>
          <img className="vector-icon185" alt="" src="../vector55.svg" />
          <img className="vector-icon186" alt="" src="../vector56.svg" />
          <img className="vector-icon187" alt="" src="../vector57.svg" />
          <img className="vector-icon188" alt="" src="../vector58.svg" />
          <img className="vector-icon189" alt="" src="../vector59.svg" />
          <img className="vector-icon190" alt="" src="../vector60.svg" />
          <img className="vector-icon191" alt="" src="../vector61.svg" />
          <img className="vector-icon192" alt="" src="../vector62.svg" />
          <img className="vector-icon193" alt="" src="../vector63.svg" />
          <img className="vector-icon194" alt="" src="../vector64.svg" />
          <img className="vector-icon195" alt="" src="../vector65.svg" />
          <img className="vector-icon196" alt="" src="../vector66.svg" />
          <img className="vector-icon197" alt="" src="../vector67.svg" />
          <img className="vector-icon198" alt="" src="../vector68.svg" />
          <img className="vector-icon199" alt="" src="../vector69.svg" />
          <img className="vector-icon200" alt="" src="../vector70.svg" />
          <img className="vector-icon201" alt="" src="../vector71.svg" />
          <img className="vector-icon202" alt="" src="../vector202.svg" />
          <img className="vector-icon203" alt="" src="../vector203.svg" />
          <img className="vector-icon204" alt="" src="../vector74.svg" />
          <img className="vector-icon205" alt="" src="../vector75.svg" />
          <img className="vector-icon206" alt="" src="../vector76.svg" />
          <img className="vector-icon207" alt="" src="../vector77.svg" />
          <img className="vector-icon208" alt="" src="../vector78.svg" />
          <img className="vector-icon209" alt="" src="../vector79.svg" />
          <b className="shuleeazy-b8">ShuleEazy</b>
        </div>
      </div>
      <div className="frame-div86">
        <b className="welcome-back">Welcome back!</b>
        <div className="a-place-to-learn-and-improve-y">
          <p className="a-place-to">A place to learn and improve</p>
          <p className="your-skills-p">your skills</p>
        </div>
      </div>
      <div className="frame-div87">
        <button className="buttondesktopprimary9">
          <img
            className="outline-24px-arrow-right4"
            alt=""
            src="../outline-24px--arrowright4.svg"
          />
          <b className="save-and-next17">login with google</b>
        </button>
        <button className="buttondesktopprimary10">
          <img
            className="outline-24px-arrow-right4"
            alt=""
            src="../outline-24px--arrowright5.svg"
          />
          <b className="save-and-next18">login with MICROSOFT</b>
        </button>
      </div>
      <div className="frame-div88">
        <div className="line-div5" />
        <b className="or-b1">OR</b>
        <div className="line-div5" />
      </div>
      <Form.Group className="input-with-label-default3">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" />
      </Form.Group>
      <Form.Group className="input-with-label-default4">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" />
      </Form.Group>
      <button className="buttondesktopprimary11">
        <b className="save-and-next18">LOGIN</b>
      </button>
      <div className="frame-div89">
        <div className="frame-div90">
          <Form.Check
            className="rectangle-formcheck10"
            name="remember"
            id="remember"
          />
          <div className="welcome-back">Remember me</div>
        </div>
        <div className="forgot-password-div1">Forgot Password</div>
      </div>
      <div className="frame-div91">
        <div className="welcome-back">New to ShuleEazy?</div>
        <b className="create-an-account" onClick={onCreateAnAccountClick}>
          <span className="create-span">Create</span>
          <span className="an-span"> an</span>
          <span className="create-span"> account</span>
        </b>
      </div>
      <div className="image-login-div1">
        <img
          className="undraw-online-learning-re-qw08-icon2"
          alt=""
          src="../undraw-online-learning-re-qw082.svg"
        />
        <img
          className="undraw-researching-re-fuod-icon2"
          alt=""
          src="../undraw-researching-re-fuod2.svg"
        />
        <img
          className="undraw-active-support-re-b7sj-icon2"
          alt=""
          src="../undraw-active-support-re-b7sj2.svg"
        />
        <img
          className="undraw-online-discussion-re-nn-icon2"
          alt=""
          src="../undraw-online-discussion-re-nn7e2.svg"
        />
        <div className="undraw-online-test-re-kyfx-div2">
          <img className="group-icon10" alt="" src="../group10.svg" />
          <img className="group-icon11" alt="" src="../group11.svg" />
          <img className="group-icon12" alt="" src="../group12.svg" />
          <img className="group-icon13" alt="" src="../group13.svg" />
          <img className="vector-icon210" alt="" src="../vector210.svg" />
          <img className="vector-icon211" alt="" src="../vector211.svg" />
          <img className="vector-icon212" alt="" src="../vector212.svg" />
          <img className="vector-icon213" alt="" src="../vector213.svg" />
          <img className="vector-icon214" alt="" src="../vector214.svg" />
          <img className="group-icon14" alt="" src="../group14.svg" />
          <div className="logo1-div8">
            <img className="vector-icon185" alt="" src="../vector215.svg" />
            <img className="vector-icon186" alt="" src="../vector216.svg" />
            <img className="vector-icon187" alt="" src="../vector217.svg" />
            <img className="vector-icon188" alt="" src="../vector218.svg" />
            <img className="vector-icon189" alt="" src="../vector219.svg" />
            <img className="vector-icon190" alt="" src="../vector220.svg" />
            <img className="vector-icon191" alt="" src="../vector221.svg" />
            <img className="vector-icon192" alt="" src="../vector222.svg" />
            <img className="vector-icon193" alt="" src="../vector223.svg" />
            <img className="vector-icon194" alt="" src="../vector224.svg" />
            <img className="vector-icon195" alt="" src="../vector225.svg" />
            <img className="vector-icon196" alt="" src="../vector226.svg" />
            <img className="vector-icon197" alt="" src="../vector227.svg" />
            <img className="vector-icon198" alt="" src="../vector228.svg" />
            <img className="vector-icon199" alt="" src="../vector229.svg" />
            <img className="vector-icon200" alt="" src="../vector230.svg" />
            <img className="vector-icon201" alt="" src="../vector231.svg" />
            <img className="vector-icon202" alt="" src="../vector232.svg" />
            <img className="vector-icon203" alt="" src="../vector233.svg" />
            <img className="vector-icon204" alt="" src="../vector234.svg" />
            <img className="vector-icon205" alt="" src="../vector235.svg" />
            <img className="vector-icon206" alt="" src="../vector236.svg" />
            <img className="vector-icon207" alt="" src="../vector237.svg" />
            <img className="vector-icon208" alt="" src="../vector238.svg" />
            <img className="vector-icon209" alt="" src="../vector239.svg" />
            <b className="shuleeazy-b9">ShuleEazy</b>
          </div>
        </div>
        <b className="shuleeazy-b10">ShuleEazy</b>
        <b className="making-school-fun-and-accessib2">
          Making school fun and accessible to everyone
        </b>
      </div>
    </div>
  );
};

export default Login;
